// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"e7926045","86":"01cb432d","248":"01cb432d","474":"01cb432d","831":"01cb432d"}[chunkId] + ".chunk.css";
};